<template>
  <div>
    <div
      v-if="packages && packages.length > 0"
      class="row btn-group">
      <div
        v-for="p in packages"
        class="col-5"
        @click="makeRequest(p.code)"
      >
        <center>
          <img
            :src="baseUrl + p.image"
            alt=""
            @error="replaceByDefault">
        </center>

        <div>{{ p.name }}</div>
        <div>{{ formatPrice(parseFloat(p.price)) }} VNĐ</div>
      </div>
    </div>
    <div class="intro">
      <img src="../../assets/img/group_benefit.png">
    </div>
  </div>
</template>

<script>
  import rf from '../../communicate/RequestFactory'
  import {errorToaster} from '../../services/ErrorHandler'
  import ApiConfig from '../../communicate/ApiConfig'
  import defaultImage from '../../assets/images/default.png'
  import {getPhone} from '../../services/authService'
  import PaymentMethod from '../../communicate/PaymentMethod'
  import OrderType from '../../communicate/OrderType'

  export default {
    name: 'UpgradeAccount',
    data: function () {
      return {
        packages: [],
        baseUrl: ApiConfig.base_url,
        loader: null,
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      makeRequest (orderCode) {
        this.loader = this.$loading.show();
        this.$Progress.start()
        const data = {
          payment_method: PaymentMethod.PAYMENT_VTC_PAY,
          order_code: orderCode
        }
        rf.getRequest('VirtualRequest').orderPackage(data).then((res) => {
          this.$Progress.finish()
          this.loader.hide();
          if (res.status === 200) {
            this.result = res.data

            const req = {
              order_id: res.data.id,
              order_code: res.data.order_code,
              customer_number: getPhone(),
              description: `Thanh toan don hang ${res.data.order_code}`,
              payment_method: PaymentMethod.PAYMENT_VTC_PAY,
              amount: res.data.price,
              payment_type: OrderType.ORDER_DT
            }

            this.requestVTC(req)

          } else {
            errorToaster('Cố vấn Phong Thủy', res.message)
          }
          this.$Progress.finish()
        }).catch(err => {
          errorToaster('Cố vấn Phong Thủy', 'Xảy ra lỗi kết nối')
          this.$Progress.fail()
          this.loader.hide();
        })
      },

      init () {
        this.$Progress.start()
        rf.getRequest('VirtualRequest').getPackages().then((res) => {
          if (res.status === 200) {
            this.packages = res.data
          } else {
            errorToaster('Cố vấn Phong Thủy', res.message)
          }
          this.$Progress.finish()
        }).catch(err => {
          errorToaster('Cố vấn Phong Thủy', 'Xảy ra lỗi kết nối')
          this.$Progress.fail()
        })
      },

      replaceByDefault (e) {
        e.target.src = defaultImage
      },

      requestVTC (req) {
        rf.getRequest('OrderRequest').vtcPay(req).then((res) => {
          if (res.status === 200 || res.status === '200') {
            window.location.href = res.data
          } else {
            // eslint-disable-next-line no-console
            console.log('Can not request to viettepay');
          }
        }).catch(err => {
          errorToaster('Cố vấn Phong Thủy', 'Xảy ra lỗi kết nối')
        })
      },

      formatPrice (value) {
        let val = (value / 1).toFixed(0).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      }
    }
  }
</script>

<style lang="scss" scoped>
  .btn-group {
    background-color: white;
    padding: 16px 5px;

    > div {
      background: #FDFCFC;
      border: 1px solid #B8B8B8;
      box-sizing: border-box;
      border-radius: 10px;
      padding: 10px;
      margin: 8px auto;

      img {
        margin: auto;
        display: table-cell;
        max-width: 70%;
      }

      > div {
        text-align: center;
        font-size: 14px;
        line-height: 16px;
        color: #000000;
        width: 100%;

        &:last-child {
          text-align: center;
          font-weight: bold;
          font-size: 18px;
          line-height: 21px;
          color: #49AF4C;
          width: 100%;
        }
      }
    }

  }

  .intro {
    background-color: white;
    padding-bottom: 16px;

    img {
      width: 100%;
      object-fit: cover;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/account/UpgradeAccount.vue